import React, { useEffect, useMemo, useState } from "react";
import { Input } from "antd";
import { NumericFormat } from "react-number-format";

/** MoneyBRLRightToLeft
 * - Digitação “da direita p/ esquerda” (centavos)
 * - Mostra BRL (R$ 1.234,56)
 * - value/onChange trabalham com Number (ex.: 1234.56)
 */
export default function MoneyBRLRightToLeft({ value, onChange, disabled, placeholder }) {
  // guarda em centavos para evitar float
  const [cents, setCents] = useState(0);

  // sincroniza quando o Form setar valor
  useEffect(() => {
    if (typeof value === "number" && !Number.isNaN(value)) {
      setCents(Math.round(value * 100));
    } else if (value == null) {
      setCents(0);
    }
  }, [value]);

  const decimal = useMemo(() => cents / 100, [cents]);

  const notify = (newCents) => {
    setCents(newCents);
    onChange?.(Number((newCents / 100).toFixed(2)));
  };

  const onKeyDown = (e) => {
    if (disabled) return;

    // backspace -> remove último dígito
    if (e.key === "Backspace") {
      e.preventDefault();
      notify(Math.floor(cents / 10));
      return;
    }

    // dígitos -> empilha no fim (shift dos centavos)
    if (/^\d$/.test(e.key)) {
      e.preventDefault();
      notify(cents * 10 + Number(e.key));
      return;
    }

    // permitir navegação/tab/ctrl-c/v etc.
    const allowed = ["Tab", "ArrowLeft", "ArrowRight", "Home", "End", "Delete", "Escape", "Enter"];
    if (allowed.includes(e.key) || e.ctrlKey || e.metaKey) return;

    // bloqueia qualquer outro caractere
    e.preventDefault();
  };

  const onPaste = (e) => {
    e.preventDefault();
    const digits = (e.clipboardData.getData("text") || "").replace(/\D/g, "");
    if (!digits) return;
    // interpreta como centavos direto (ex.: "1234" => 12,34)
    notify(Number(digits));
  };

  return (
    <NumericFormat
      value={decimal}                   // exibe 12.34 => R$ 12,34
      customInput={Input}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale
      prefix="R$ "
      allowNegative={false}
      inputMode="numeric"
      placeholder={placeholder ?? "R$ 0,00"}
      disabled={disabled}
      // controlamos por keydown/paste; não deixamos digitar vírgula/ponto
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      onValueChange={() => {}} // noop (mantemos controle por cents)
    />
  );
}
